const MAP_PIN_SIZE = { width: 36, height: 48 };

function getMapPinIcon() {
    const themeUrl = typeof window !== 'undefined' && window.js_vars?.themeurl ? window.js_vars.themeurl : '';

    return {
        url: `${themeUrl}/dist/images/map-pin.svg`,
        scaledSize: new google.maps.Size(MAP_PIN_SIZE.width, MAP_PIN_SIZE.height),
        anchor: new google.maps.Point(MAP_PIN_SIZE.width / 2, MAP_PIN_SIZE.height),
    };
}

/**
 * initMap
 *
 * Renders a Google Map onto the selected element
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   HTMLElement el The map container element.
 * @return  object The map instance.
 */
function initMap(el) {
    // Find marker elements within map.
    var markers = el.querySelectorAll('.marker');

    // Create gerenic map.
    var mapArgs = {
        zoom: parseInt(el.dataset.zoom, 10) || 16,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        zoomControl: true,
        zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_BOTTOM,
        },
        styles: [
            {
                featureType: 'all',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        saturation: 36,
                    },
                    {
                        color: '#000000',
                    },
                    {
                        lightness: 40,
                    },
                ],
            },
            {
                featureType: 'all',
                elementType: 'labels.text.stroke',
                stylers: [
                    {
                        visibility: 'on',
                    },
                    {
                        color: '#000000',
                    },
                    {
                        lightness: 16,
                    },
                ],
            },
            {
                featureType: 'all',
                elementType: 'labels.icon',
                stylers: [
                    {
                        visibility: 'off',
                    },
                ],
            },
            {
                featureType: 'administrative',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        color: '#000000',
                    },
                    {
                        lightness: 20,
                    },
                ],
            },
            {
                featureType: 'administrative',
                elementType: 'geometry.stroke',
                stylers: [
                    {
                        color: '#000000',
                    },
                    {
                        lightness: 17,
                    },
                    {
                        weight: 1.2,
                    },
                ],
            },
            {
                featureType: 'administrative',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        lightness: '62',
                    },
                ],
            },
            {
                featureType: 'landscape',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#000000',
                    },
                    {
                        lightness: 20,
                    },
                ],
            },
            {
                featureType: 'landscape',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        lightness: '0',
                    },
                ],
            },
            {
                featureType: 'landscape',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        lightness: '69',
                    },
                ],
            },
            {
                featureType: 'poi',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#000000',
                    },
                    {
                        lightness: 21,
                    },
                ],
            },
            {
                featureType: 'road',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        lightness: '63',
                    },
                ],
            },
            {
                featureType: 'road.highway',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        color: '#2d2d2d',
                    },
                    {
                        lightness: 17,
                    },
                ],
            },
            {
                featureType: 'road.highway',
                elementType: 'geometry.stroke',
                stylers: [
                    {
                        color: '#000000',
                    },
                    {
                        lightness: 29,
                    },
                    {
                        weight: 0.2,
                    },
                ],
            },
            {
                featureType: 'road.arterial',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#000000',
                    },
                    {
                        lightness: 18,
                    },
                ],
            },
            {
                featureType: 'road.local',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#000000',
                    },
                    {
                        lightness: 16,
                    },
                ],
            },
            {
                featureType: 'transit',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#000000',
                    },
                    {
                        lightness: 19,
                    },
                ],
            },
            {
                featureType: 'water',
                elementType: 'geometry',
                stylers: [
                    {
                        color: '#0f252e',
                    },
                    {
                        lightness: 17,
                    },
                ],
            },
            {
                featureType: 'water',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        lightness: '-100',
                    },
                    {
                        gamma: '0.00',
                    },
                ],
            },
        ],
    };
    var map = new google.maps.Map(el, mapArgs);

    // Add markers.
    map.markers = [];
    markers.forEach(function (markerEl) {
        initMarker(markerEl, map);
    });

    // Center map based on markers.
    centerMap(map);

    // Return map instance.
    return map;
}

/**
 * initMarker
 *
 * Creates a marker for the given element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   HTMLElement markerEl The marker element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
function initMarker(markerEl, map) {
    // Get position from marker.
    var lat = markerEl.dataset.lat;
    var lng = markerEl.dataset.lng;
    var latLng = {
        lat: parseFloat(lat),
        lng: parseFloat(lng),
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
        position: latLng,
        map: map,
        icon: getMapPinIcon(),
    });

    // Append to reference for later use.
    map.markers.push(marker);

    // If marker contains HTML, add it to an infoWindow.
    var markerHtml = markerEl.innerHTML;
    if (markerHtml && markerHtml.trim()) {
        // Create info window.
        var infowindow = new google.maps.InfoWindow({
            content: markerHtml,
        });

        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function () {
            infowindow.open(map, marker);
        });
    }
}

/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
function centerMap(map) {
    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng(),
        });
    });

    // Case: Single marker.
    if (map.markers.length == 1) {
        map.setCenter(bounds.getCenter());

        // Case: Multiple markers.
    } else {
        map.fitBounds(bounds);
    }
}

export function initAcfMaps() {
    if (typeof window === 'undefined') return;
    if (typeof window.google === 'undefined' || !window.google?.maps) return;
    if (!document.querySelector('.acf-map')) return;

    document.querySelectorAll('.acf-map').forEach(function (mapEl) {
        initMap(mapEl);
    });
}
